var InfoScreenOption = /** @class */ (function () {
    function InfoScreenOption(input, toggleClass, container) {
        this.input = input;
        this.toggleClass = toggleClass;
        this.container = container;
        this.initEvents();
    }
    InfoScreenOption.prototype.initEvents = function () {
        var _this = this;
        this.input.addEventListener('change', function () {
            _this.input.checked
                ? _this.container.classList.add(_this.toggleClass)
                : _this.container.classList.remove(_this.toggleClass);
        });
    };
    return InfoScreenOption;
}());
export default InfoScreenOption;
